export const CASES = {
    UPDATE_TAGS: 'UPDATE_TAGS',
    UPDATE_TAGS_FILTER_FORM: 'UPDATE_TAGS_FILTER_FORM',
    CLEAR_TAGS: 'CLEAR_TAGS',
};
